import api from '../../axiosConfig'
export default{
    mutations: {
        Result: () => {
            return false
        }
    },
    actions:{
        TrackEvents({commit}, event) {
            return new Promise ((resolve, reject) => {
                let config = {
                    headers: {
                        'x-api-key': localStorage.getItem('userToken')
                    }
                }
                commit('Result')
                api.post('/api/v2/track-event', event, config).then(res => {
                    resolve(res)
                }).catch(err => {
                    reject(err)
                })
            })
        },
    }
} 
